import { render, staticRenderFns } from "./TheBasic6DigitUSSGLAccountsClassification.vue?vue&type=template&id=65d96980&scoped=true&"
import script from "./TheBasic6DigitUSSGLAccountsClassification.vue?vue&type=script&lang=js&"
export * from "./TheBasic6DigitUSSGLAccountsClassification.vue?vue&type=script&lang=js&"
import style0 from "./TheBasic6DigitUSSGLAccountsClassification.vue?vue&type=style&index=0&id=65d96980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d96980",
  null
  
)

export default component.exports